import * as IwDataDogLogger from '../loggers/IwDataDogLogger';

export default function errorReporter() {
    return function wrapDispatchToAddReporting(next) {
        return function dispatchOrReport(action) {
            try {
                return next(action);
            } catch (exception) {
                console.error(exception);

                IwDataDogLogger.logError({
                    message: `ACTION: ${action.type}`,
                    tags: {
                        reporter: 'reducer'
                    },
                    extra: {
                        description: exception.message
                    }
                });

                throw exception;
            }
        };
    };
}
